import Vue from "vue";

export default (context) =>
  Vue.$http
    .post("/airbnb/user-create", {
      code: context.code,
      state: context.state,
    })
    .then((response) => {
      context.currentAibnbAccountId = response.data.airbnb_account.id;
    })
    .catch((error) => {
      context.error = error.response.data.msg;
      toastr.error(error.response.data.msg);
    })
    .finally(() => {
      context.$router.push({
        name: "account.settings.tab",
        params: { tab: context.activeTab },
      });
    });



// WEBPACK FOOTER //
// ./src/app/services/airbnb/user-create.js